import { Link, useLocation, useNavigate } from "react-router-dom";
import { PackageSearch, LayoutDashboard, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export const Header = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
        <Link to="/" data-testid="brand-home-link" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-900">
            <PackageSearch className="h-5 w-5 text-orange-500" strokeWidth={2.2} />
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-slate-900">
            TransitLine <span className="text-orange-600">Express</span>
          </span>
        </Link>

        <nav className="flex items-center gap-2">
          {loc.pathname !== "/" && (
            <Button variant="ghost" size="sm" data-testid="nav-track-link" onClick={() => nav("/")}>
              Track
            </Button>
          )}
          {user ? (
            <>
              <Button
                variant="ghost"
                size="sm"
                data-testid="nav-dashboard-link"
                onClick={() => nav("/dashboard")}
                className="gap-1.5"
              >
                <LayoutDashboard className="h-4 w-4" /> Dashboard
              </Button>
              <Button
                variant="outline"
                size="sm"
                data-testid="nav-logout-btn"
                onClick={async () => {
                  await logout();
                  nav("/");
                }}
                className="gap-1.5"
              >
                <LogOut className="h-4 w-4" /> Sign out
              </Button>
            </>
          ) : (
            <Button
              size="sm"
              data-testid="nav-staff-login-btn"
              onClick={() => nav("/login")}
              className="bg-slate-900 hover:bg-slate-800"
            >
              Staff Login
            </Button>
          )}
        </nav>
      </div>
    </header>
  );
};
